/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_Sem_Id_HintInputs */

const cs_sklik_sem_id_hint = /** @type {(inputs: Sklik_Sem_Id_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z pokročilého nastavení Seznam Event Measurement (S2S ID, ne browser SEM ID). Potřeba pro odesílání konverzí Lead.`)
};

const en_sklik_sem_id_hint = /** @type {(inputs: Sklik_Sem_Id_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From Sklik Event Measurement advanced settings (S2S ID, not the browser SEM ID). Required to send Lead conversions.`)
};

/**
* | output |
* | --- |
* | "From Sklik Event Measurement advanced settings (S2S ID, not the browser SEM ID). Required to send Lead conversions." |
*
* @param {Sklik_Sem_Id_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_sem_id_hint = /** @type {((inputs?: Sklik_Sem_Id_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_Sem_Id_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_sem_id_hint(inputs)
	return cs_sklik_sem_id_hint(inputs)
});